export default "__VITE_ASSET__206ae5c5__"